export { SettingsAvatarScreen as default } from '@/src/features/settings/ui/screens/SettingsAvatarScreen'
